<template>
  <div class="animated fadeIn row">
    <div class="card w-full">
      <div class="card-header">
        <strong>เพิ่มบทความ <i class="far fa-plus"></i></strong>
      </div>
      <div class="card-body">
        <div v-if="submit.active==false">
          <div class="col-lg-12 col-sm-12 form-group row" v-if="article.languages.data.length != 1">
            <div v-for="language in article.languages.data" :key="language.short_name" class="mx-1 text-center">
              <b-button block variant="outline-info" @click="setLanguage(language.short_name)" :class="{active: language.short_name === data.lang }">
                {{ language.name }}
                <span v-bind:class="'flag-icon flag-icon-us'" v-if="covertoLowerCase(language.short_name)=='en'"></span>
                <span v-bind:class="'flag-icon flag-icon-'+covertoLowerCase(language.short_name)" v-if="covertoLowerCase(language.short_name)!='en'"></span>
              </b-button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">ชื่อบทความ<span v-if="data.article.lang!=''"> {{data.article.lang}}</span>&nbsp;<i
                    class="far fa-bookmark"></i>
                  : </label>
                <input class="form-control" v-model="data.article[data.lang].title" type="text" placeholder="กรุณากรอกชื่อบทความ">
              </div>
            </div>
          </div>
          <div class="row form-group">
            <rich-editor class="col-sm-12" v-model="data.article[data.lang].description"></rich-editor>
          </div>
          <div class="row mb-2">
            <div class="col-lg-9">
              <multiselect placeholder="หมวดหมู่บทความ" v-model="article.categories.selected" :multiple="true" :options="article.categories.options"
                track-by="name" label="name" :preselect-first="true"></multiselect>
            </div>
            <div class="col-lg-3">
              <button class="btn btn-primary w-full" type="button" @click="openCategories()"><i class="far fa-layer-plus"></i>
                เพิ่มหมวดหมู่</button>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label for="name">วันที่สร้าง: </label>
              <datepicker :bootstrap-styling="true" v-model="data.article[data.lang].created_at" placeholder="กรุณาคลิกเลือกวันที่สร้าง"></datepicker>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group row" v-if="data.image!=''">
              <div class="offset-lg-3 col-lg-6 text-center">
                <label for="ccnumber">รูปตัวอย่าง <i class="far fa-image"></i></label>
                <img v-bind:src="data.image" @error="imageLoadError" class="d-block w-full">
              </div>
            </div>
            <div class="form-group row">
              <div class="offset-lg-2 col-lg-4">
                <button type="button" class="btn btn-outline-primary btn-block w-full" @click="openModal('upload')"><i
                    class="far fa-upload"></i> อัพโหลดรูปจากเครื่อง</button>
              </div>
              <div class="col-lg-4">
                <button type="button" class="btn btn-outline-info btn-block w-full" @click="openModal('link')"><i class="far fa-link"></i>
                  อัพโหลดรูปจากลิงค์</button>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="offset-sm-3 offset-lg-3 col-sm-3 col-lg-3">
              <button class="btn btn-primary w-full" type="submit" @click="submitArticle"><i class="far fa-clipboard-check"></i>
                ยืนยัน</button>
            </div>
            <div class="col-sm-3 col-lg-3">
              <router-link :to="{ name: 'ArticleList'}"><button class="btn btn-secondary w-full" type="button"><i class="far fa-times-square"></i>
                  ยกเลิก</button></router-link>
            </div>
          </div>
        </div>
        <div v-if="submit.active">
          <div class="loader-container-4tiles clearfix">
            <div class="square s9 rounded"></div>
            <div class="square s2 rounded"></div>
            <div class="square s1 rounded"></div>
            <div class="square s6 rounded"></div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-bind:title="article.modal.title" ref="model" hide-footer v-model="article.modal.active" @ok="article.modal.active = false">
      <div v-if="article.modal.action=='link'">
        <div class="row">
          <div class="col-md-12">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">URL</span>
              </div>
              <input type="text" class="form-control" v-model="data.image">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <b-btn class="mt-3" variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
          </div>
          <div class="col-lg-6">
            <b-btn class="mt-3" variant="outline-secondary" block @click="cancleImageLink">ยกเลิกการเปลี่ยนแปลง</b-btn>
          </div>
        </div>
      </div>
      <div v-if="article.modal.action=='upload'">
        <div v-if="article.img.upload.active==false">
          <div class="custom-file" v-if="article.img.crop.active">
            <input type="file" name="image" accept="image/*" class="custom-file-input" @change="setImage" />
            <label class="custom-file-label" for="customFile">Choose file</label>
          </div>
          <div v-if="article.img.view.active">
            <div v-if="article.img.crop.active" style="width: 100%; height:68.5%; border: 1px solid gray; display: inline-block;">
              <vue-cropper ref='cropper' :src="article.img.view.src" :guides="true" :view-mode="2" drag-mode="crop"
                :initialAspectRatio="100/68.5" :aspectRatio="100/68.5" :auto-crop-area="0.5" :min-container-width="100"
                :min-container-height="68.5" :background="true" :rotatable="true" alt="zeedoc-img-article" :img-style="{ 'width': '100%', 'height': '68.5%' }">
              </vue-cropper>
            </div>
            <div>
              <div v-if="!article.img.crop.active">
                <label for="ccnumber">ภาพที่จะแสดงในบทความ <i class="far fa-image"></i></label>
                <img :src="article.img.crop.src" style="width: 100%; height: 68.5%; border: 1px solid gray" alt="ตัวอย่างรูปที่จะนำเข้า" />
                <hr>
              </div>
            </div>
          </div>
          <div class="row" v-if="article.img.crop.active && article.img.view.src">
            <div class="offset-lg-2 col-lg-8">
              <br />
              <b-btn @click="cropImage" variant="primary" block>เลือกภาพนี้</b-btn>
            </div>
          </div>
          <div class="row" v-if="!article.img.crop.active && article.img.crop.src">
            <div class="col-lg-6">
              <b-btn variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
            </div>
            <div class="col-lg-6">
              <b-btn @click="cancleImage" variant="secondary" block>ยกเลิกภาพ</b-btn>
            </div>
          </div>
        </div>
        <div v-if="article.img.upload.active">
          <div class="loader-container-4tiles clearfix">
            <div class="square s9 rounded"></div>
            <div class="square s2 rounded"></div>
            <div class="square s1 rounded"></div>
            <div class="square s6 rounded"></div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-bind:title="article.categories.modal.title" ref="model" hide-footer v-model="article.categories.modal.active"
      @ok="article.categories.modal.active = false">
      <div class="row" v-if="article.categories.modal.upload.active==false">
        <div class="col-md-12">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">ชื่อหมวดหมู่: </span>
            </div>
            <input type="text" class="form-control" v-model="article.categories.data.title">
            <div class="input-group-prepend">
              <button type="button" style="background-color: #337ab7;color:#ffffff" class="btn btn-primary input-group-text"
                @click="addModalCategory">เพิ่ม</button>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <ul class="list-group">
            <li class="list-group-item" v-for="category in article.categories.options" :key="category.id">
              <div class="row">
                <div class="col-sm-9 col-lg-9 col-md-9 text-center">{{ category.name }}</div>
                <div class="col-sm-3 col-lg-3 col-md-3"><button type="button" class="btn btn-danger form-control"
                    @click="openAlertRemove(category.id,category.name)"><i class="fas fa-layer-minus"></i> ลบ</button></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="article.categories.modal.upload.active">
        <div class="loader-container-4tiles clearfix">
          <div class="square s9 rounded"></div>
          <div class="square s2 rounded"></div>
          <div class="square s1 rounded"></div>
          <div class="square s6 rounded"></div>
        </div>
      </div>
    </b-modal>
    <b-modal v-bind:title="article.categories.alert.title" ref="model" hide-footer v-model="article.categories.alert.active"
      @ok="article.categories.alert.active = false">
      <div class="row" v-if="article.categories.alert.upload.active==false">
        <div class="col-md-12 text-center">
          <p v-html="article.categories.alert.detail"></p>
          <div class="row">
            <div class="col-md-6">
              <button type="button" class="btn btn-danger form-control" @click="removeCategory()">ยืนยันการลบ</button>
            </div>
            <div class="col-md-6">
              <button type="button" class="btn btn-light form-control" @click="openCategories()">ยกเลิก</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="article.categories.alert.upload.active">
        <div class="loader-container-4tiles clearfix">
          <div class="square s9 rounded"></div>
          <div class="square s2 rounded"></div>
          <div class="square s1 rounded"></div>
          <div class="square s6 rounded"></div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueCropper from 'vue-cropperjs'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import Multiselect from 'vue-multiselect'
  import Helper from '@/shared/helper'
  import RichEditor from '@/components/richEditor'
  import uploadImage from '@/components/uploadImage'
  import Datepicker from 'vuejs-datepicker'
  export default {
    components: {
      Datepicker,
      Multiselect,
      VueCropper,
      RichEditor,
      uploadImage
    },
    mixins: [Helper],
    data() {
      return {
        load: 0,
        submit: {
          active: false,
          error: false
        },
        no_image: {
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        article: {
          id: parseInt(this.$route.params.id),
          languages: {
            count: 1,
            data: []
          },
          categories: {
            data: {
              title: ''
            },
            options: [],
            selected: [],
            alert: {
              detail: '',
              title: 'คุณต้องการลบใช่หรือไม่?',
              action: '',
              active: false,
              upload: {
                id: '',
                active: false
              }
            },
            modal: {
              title: 'เพิ่มหมวดหมู่',
              action: '',
              active: false,
              upload: {
                active: false
              }
            }
          },
          img: {
            upload: {
              active: false
            },
            view: {
              src: '',
              active: false
            },
            crop: {
              src: '',
              active: false
            }
          },
          modal: {
            title: '',
            action: '',
            active: false
          },
        },
        authorization: 'Bearer ' + localStorage.getItem('z_token'),
        data: {
          page: 0,
          per_page: 0,
          lang: 'th',
          categories: [],
          session: [],
          image: '',
          article: {
            th: {
              id: '',
              title: '',
              description: '',
              lang: '',
              created_at: ''
            }
          }
        }
      }
    },
    methods: {
      covertoLowerCase(title) {
        if (title && title != '') {
          return title.toLowerCase()
        } else {
          return title
        }
      },
      openAlertRemove(id, name) {
        this.article.categories.alert.detail = 'คุณต้องการลบหมวดหมู่ "<b>' + name + '</b>" ใช่หรือไม่?'
        this.article.categories.alert.active = true
        this.article.categories.modal.upload.id = id
      },
      addModalCategory() {
        if (this.article.categories.data.title.length > 5) {
          this.article.categories.modal.upload.active = true
          this.$http.post(process.env.VUE_APP_API_URL + 'api/v1/categories', {
            'name': this.article.categories.data.title,
            'locale': this.data.lang,
          }, {
            headers: {
              Authorization: this.authorization
            }
          }).then(function (response) {
            this.article.categories.modal.upload.active = false
            this.article.categories.data.title = ''
            this.article.categories.options.push(response.body.json)
            alert('หมวดหมู่หมายเลข: ' + response.body.json.id + ' ชื่อ:' + response.body.json.name +
              ' สร้างเรียบร้อย');
          }).catch(function (error) {
            this.article.categories.modal.upload.active = false
            alert('ไม่สามารถสร้างหมวดหมู่ได้ กรุณากรอกชื่อของหมวดหมู่!');
          })
        } else {
          alert('กรุณากรอกชื่อของหมวดหมู่และมากกว่า5ตัวอักษร')
        }
      },
      removeCategory() {
        if (this.article.categories.modal.upload.id) {
          this.article.categories.alert.upload.active = true
          this.$http.delete(process.env.VUE_APP_API_URL + 'api/v1/categories/' + this.article.categories.modal.upload.id, {
            headers: {
              Authorization: this.authorization
            }
          }).then(function (response) {
            this.article.categories.alert.upload.active = false
            let item;
            let array = [];
            for (item in this.article.categories.options) {
              if (this.article.categories.options[item].id != this.article.categories.modal.upload.id) {
                array.push(this.article.categories.options[item])
              }
            }
            this.article.categories.options = array
            array = []
            for (item in this.article.categories.selected) {
              if (this.article.categories.selected[item].id != this.article.categories.modal.upload.id) {
                array.push(this.article.categories.selected[item])
              }
            }
            this.article.categories.selected = array
            alert('ทำการลบหมวดหมู่หมายเลข: ' + this.article.categories.modal.upload.id + ' เรียบร้อย');
            this.openCategories();
          }).catch(function (error) {
            this.article.categories.alert.upload.active = false
            alert('ไม่สามารถลบหมวดหมู่ได้ กรุณาตรวจสอบเครือข่าย!');
          })
        } else {
          alert('ไม่สามารถลบหมวดหมู่นี้ได้ เปิดหน้านี้ใหม่อีกครั้ง')
        }
      },
      openCategories() {
        this.article.categories.data.title = ''
        this.article.categories.modal.active = true
        this.article.categories.modal.upload.active = false
      },
      openModal(action) {
        this.article.img.view.active = false
        this.article.modal.action = action
        this.article.img.crop.active = true
        if (action == 'upload') {
          this.article.img.view.src = null
          this.article.modal.title = 'อัพโหลดรูปจากเครื่อง'
          this.article.modal.active = true
        } else if (action == 'link') {
          this.article.modal.title = 'อัพโหลดรูปจากลิงค์'
          this.article.modal.active = true
        }
      },
      setLanguage(language) {
        this.data.lang = language
      },
      setImage(e) {
        const file = e.target.files[0]
        this.article.img.view.active = true
        if (!file.type.includes('image/')) {
          alert('Please select an image file')
          return
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.article.img.view.src = event.target.result
            this.$refs.cropper.replace(event.target.result)
          }
          reader.readAsDataURL(file)
        } else {
          alert('Sorry, FileReader API not supported')
        }
      },
      submitArticle() {
        let obj;
        this.data.categories = []
        for (obj in this.article.categories.selected) {
          this.data.categories.push(this.article.categories.selected[obj].id)
        }
        if (this.article.id != '' && this.article.id) {
          this.checkUpdateArticle()
        } else {
          this.checkArticle()
        }
      },
      checkArticle() {
        this.data.session = []
        let item = null
        let isVal = false
        let emtpyCount = 0
        let data = []
        this.startLoad(this.article.languages.count)
        for (item in this.data.article) {
          if (this.data.article[item].title != '' && this.data.article[item].title) {
            if (isVal) {
              this.data.session[item] = this.data.article[item]
            } else {
              if (this.data.article[item].title.length > 5) {
                this.submit.active = true
                this.createArticle({
                  'title': this.data.article[item].title,
                  'description': this.data.article[item].description,
                  'image': this.data.image,
                  'created_at': this.data.article[item].created_at,
                  'locale': item,
                  'category_id': this.data.categories
                }, true)
              } else {
                this.checkLoad()
                alert("กรุณากรอกชื่อของบทความที่มีความยามมากกว่า5ตัวอักษร (" + item + ")")
              }
            }
            isVal = true
          } else {
            this.checkLoad()
            emtpyCount = emtpyCount + 1
            if (emtpyCount == this.article.languages.count) {
              this.submit.active = false
              alert('กรุณาใส่ข้อมูลของบทความ')
            }
          }
        }
      },
      imageLoadError(event) {
        this.data.image = ''
        event.target.src = this.no_image.src
      },
      createArticle(data, isfunc) {
        this.$http.post(process.env.VUE_APP_API_URL + 'api/v1/articles', data, {
          headers: {
            Authorization: this.authorization
          }
        }).then(function (response) {
          let item = null
          this.checkLoad()
          if (isfunc == true) {
            for (item in this.data.session) {
              this.createArticle({
                'title': this.data.session[item].title,
                'description': this.data.session[item].description,
                'created_at': this.data.session[item].created_at,
                'image': this.data.session[item].image,
                'id': response.body.json.article.id,
                'locale': item,
                'category_id': this.data.categories
              }, false);
            }
          }
          if (this.load == 0) {
            alert('บทความสร้างเรียบร้อย');
            this.$router.push({
              name: 'ArticleList'
            })
          }
        }).catch(function (error) {
          if (this.submit.error == false) {
            this.submit.error = true
            alert('ไม่สามารถสร้างบทความได้ กรุณากรอกชื่อของบทความ!');
            this.$router.push({
              name: 'ArticleList'
            })
          }
        })
      },
      async updateArticle(data) {
        try {
          await this.$http.put(process.env.VUE_APP_API_URL + 'api/v1/articles/' + this.article.id, data, {
            headers: {
              Authorization: this.authorization
            }
          })
        } catch (e) {
          if (this.submit.error == false) {
            this.submit.error = true
            alert('ไม่สามารถสร้างบทความได้ กรุณากรอกชื่อของบทความ!')
            this.$router.push({
              name: 'ArticleList'
            })
          }
        }
        this.checkLoad()
      },
      async checkUpdateArticle() {
        let item = null
        let emtpyCount = 0
        this.startLoad(this.article.languages.count)
        for (item in this.data.article) {
          if (this.data.article[item].title != '' && this.data.article[item].title) {
            if (this.data.article[item].title.length > 5) {
              this.submit.active = true
              await this.updateArticle({
                'id': this.data.article[item].id,
                'title': this.data.article[item].title,
                'description': this.data.article[item].description,
                'created_at': this.data.article[item].created_at,
                'image': this.data.image,
                'locale': item,
                'category_id': this.data.categories
              })
            } else {
              this.checkLoad()
              alert("กรุณากรอกชื่อของบทความที่มีความยามมากกว่า5ตัวอักษร (" + item + ")")
            }
          } else {
            this.checkLoad()
            emtpyCount = emtpyCount + 1
            if (emtpyCount == this.article.languages.count) {
              this.submit.active = false
              alert('กรุณาใส่ข้อมูลของบทความ')
            }
          }
        }
        if (this.load == 0) {
          alert('บทความอัพเดทเรียบร้อย')
          this.$router.push({
            name: 'ArticleList'
          })
        }
      },
      cropImage() {
        this.article.img.crop.active = false
        this.article.img.crop.src = this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg')
      },
      submitImage() {
        if (this.article.img.crop.src != '' && this.article.img.crop.src) {
          this.article.img.upload.active = true
          this.$http.post(process.env.VUE_APP_AWS_URL + 'upload/image', {
            'storage_name': 'musigahealthcare',
            'base64String': this.article.img.crop.src.replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
          }, {
            headers: {
              Authorization: this.authorization
            }
          }).then(function (response) {
            this.article.img.upload.active = false
            this.data.image = response.data.result
            this.cancleImageLink
            this.$refs.model.hide()
          }).catch(function (error) {
            this.article.img.upload.active = false
            alert('คุณใส่ชนิดหรือรูปแบบของรูปภาพไม่ถูกต้อง!')
            this.cancleImageLink
            this.$refs.model.hide()
          })
        } else {
          this.article.img.upload.active = false
          this.$refs.model.hide()
        }
      },
      cancleImage() {
        this.article.img.view.src = null
        this.article.img.view.active = false
        this.article.img.crop.active = true
        this.article.img.crop.src = null
      },
      cancleImageLink() {
        this.article.img.view.active = false
        this.article.img.crop.active = true
        this.article.img.crop.src = null
        this.data.image = ''
      },
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      checkCategories() {
        let obj, val;
        for (val in this.data.categories) {
          for (obj in this.article.categories.options) {
            if (this.article.categories.options[obj].id == this.data.categories[val]) {
              this.article.categories.selected.push(this.article.categories.options[obj])
              break
            }
          }
        }
      },
      getArticleByID(id, lang) {
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/articles/' + id, {
          params: {
            lang: lang
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          if (response.body.json) {
            this.data.article[response.body.json.locale].id = response.body.json.id
            this.data.article[response.body.json.locale].title = response.body.json.title
            this.data.article[response.body.json.locale].description = response.body.json.description
            this.data.article[response.body.json.locale].created_at = response.body.json.created_at
            if (response.body.json.image && response.body.json.image != '') {
              this.data.image = response.body.json.image
            } else {
              this.data.image = this.no_image.src
            }
            this.data.categories = response.body.json.categories
            if (this.load == 0) {
              this.checkCategories()
            }
          }
        }, response => {
          this.checkLoad()
        })
      },
      getLanguages() {
        this.startLoad(1)
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/languages', {
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          const numLanguage = response.body.json.length
          let item = null
          if (numLanguage >= 1) {
            this.article.languages.count = response.body.json.length
            this.article.languages.data = response.body.json
            this.startLoad(this.article.languages.count + 1)
            for (item in this.article.languages.data) {
              this.data.article[this.article.languages.data[item].short_name] = {
                title: '',
                image: '',
                created_at: '',
                description: '',
                lang: ''
              }
              if (Number.isInteger(this.article.id)) {
                this.getArticleByID(this.article.id, this.article.languages.data[item].short_name)
              }
            }
            this.setLanguage(this.article.languages.data[0].short_name)
            this.getCategories()
          }
        }, response => {
          this.failLoad()
        })
      },
      getCategories() {
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/categories', {
          params: {
            lang: this.data.article.lang,
            per_page: 100
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.article.categories.options = response.body.json.data
          this.checkLoad()
        }, response => {
          this.failLoad()
        });
      }
    },
    mounted() {
      this.getLanguages()
    }
  }

</script>
<style lang="scss">
  .ql-editor {
    height: 20rem !important;
  }

</style>
